import React, { useEffect, useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, FlexView, Table, Spinner, Link, Button } from "../components/common"
import { Input } from 'components/form'
import styled from "styled-components"
import { SafetyStockContext } from "stores/SafetyStockStore"
import { AppContext } from "stores/AppStore"
import { Multiselect } from 'multiselect-react-dropdown'
import { toast } from "react-toastify"
import { formatNm } from "../utils/format"

const Grid = styled(FlexView)`
  flex: 1;
  width: 100%;
  display: grid;
  align-items: stretch;
  grid-template-columns: 25% 25% 50%;
  max-height: 400px;

  @media screen and (max-width: 700px) {
    grid-template-columns: 100%;
  }
`
const multiselectCss = { 
  multiselectContainer: {},
  searchBox: {
    minHeight: '28px'
  }, 
  inputField: {}, 
  chips: { 
    borderRadius: '5px', 
    // maxWidth: '150px', 
    textOverflow: 'ellipsis' 
  }, 
  optionContainer: { 
    fontSize: '12px', 
    boxShadow: 'rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px, rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px', 
    borderRadius: '6px' 
  }
}

const SafetyRegisterNm = () => {
  const { setPageSubtitle } = useContext(AppContext)
  const { t } = useTranslation()
  const {
    getSafetyStockRegisterNm,
    SafetyStockCrudRegisterNm
  } = useContext(SafetyStockContext)

  const [loadingFilters, setLoadingFilters] = useState(false)
  const [table, setTable] = useState([])
  const [clients, setClients] = useState()
  const [nms, setNms] = useState()
  const [pieces, setPieces] = useState()
  const [plant, setPlant] = useState()
  const [contract, setContract] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const [selectedNm, setSelectedNm] = useState()
  const [edit, setEdit] = useState(false)

  const columns = [
    {
      Header: t("safety.table.dscCustomer"),
      accessor: "client",
      id: "client",
    },
    {
      Header: t("safety.table.nm"),
      accessor: (row) => formatNm(row.nm),
      id: "nm",
    },
    {
      Header: t("safety.table.total"),
      accessor: "total",
      id: "total",
    },
    {
      Header: t("safety.table.plant"),
      accessor: "plant",
      id: "plant",
    },
    {
      Header: t("safety.table.contract"),
      accessor: "contract",
      id: "contract",
    },
    {
      Header: t("safety.table.edit"),
      accessor: (row) => <Link onClick={ () =>  onEditClick(row)} >Editar </Link>,
      id: "edit",
    },
    {
      Header: t("safety.table.delete"),
      accessor: (row) => <Link onClick={() => onDeleteClick(row)} >Deletar </Link>,
      id: "delete",
    }
  ]

  const LabelMultiselect = ({ label, loading }) => {
    return (  
        <FlexView flexDirection="row" justifyContent="flex-start" margin="4px 0px">
            <FlexView color="gray" fontSize="medium" fontWeight="700">{label}:</FlexView>
            { loading ? <Spinner style={{margin: "0px 10px"}} size="medium"/> : <></> }
        </FlexView>
    )
  }

  useEffect(() => {
    setPageSubtitle(t('safety.pageTitle'))
  }, [setPageSubtitle, t])

  useEffect(() => {
    setLoadingFilters(true)
    setClients()
    setNms()
    setSelectedClient()
    setSelectedNm()

    getSafetyStockRegisterNm({ init: true }).then(data => {
      setClients(data.filterData.clients)
      setTable(data.tableData)
      setNms(data.filterData.nms)
      setLoadingFilters(false)
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onClientSelect = (selectedList) => {
    setSelectedClient(selectedList)
  }

  const onNmSelect = (selectedList) => {
    setSelectedNm(selectedList)
  }
  
  const handleInputChange = (event) => {
    event.persist()
    
    if (event.target.name === 'plant') {
      setPlant(event.target.value)
    } else if (event.target.name === 'contract') {
      setContract(event.target.value)
    }else if(event.target.name === 'pieces') {
      setPieces(event.target.value)
    }
  }

  const   handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSaveClick()
    }
  }

  const onEditClick = (row) => {
    setEdit(true)
    setSelectedClient([{ value: row.customer, label: row.client }])
    setSelectedNm([{ value: row.nm, label: row.nm}])
    setPieces(row.total)
    setPlant(row.plant)
    setContract(row.contract)
  }

  const onCancelClick = () => {
    setEdit(false)
    setSelectedClient()
    setSelectedNm()
    setPieces('')
    setPlant('')
    setContract('')

  }

  const validateForm = () => {
    if (!selectedClient || selectedClient.length === 0) {
      toast.error(t('safety.errors.clientRequired') || "Client is required");
      return false;
    }
    if (!selectedNm || selectedNm.length === 0) {
      toast.error(t('safety.errors.nmRequired') || "NM is required");
      return false;
    }
    if (!pieces || isNaN(Number(pieces)) || Number(pieces) <= 0) {
      toast.error(t('safety.errors.piecesRequired') || "Pieces must be a positive number");
      return false;
    }
    if (!plant || plant.trim() === "") {
      toast.error(t('safety.errors.plantRequired') || "Plant is required");
      return false;
    }
    if (!contract || contract.trim() === "") {
      toast.error(t('safety.errors.contractRequired') || "Contract is required");
      return false;
    }
    return true;
  } 
  
  const onUpdateClick = (row) => {
    if (!validateForm())
      return;

    setIsLoading(true)
    SafetyStockCrudRegisterNm({
      type: 'update',
      client: selectedClient.map(x => { return x.value }),
      nm: selectedNm.map(x => { return x.value }),
      pieces,
      plant,
      contract
     }).then(data => {
       setTable(data.tableData)
       setIsLoading(false)
       setLoadingFilters(false)
       onCancelClick()
     })
     .catch(error => {
        toast.error(t('errors.' + error))
        setIsLoading(false)
    })
  }

  const onDeleteClick = (row) => {
    setIsLoading(true)
    SafetyStockCrudRegisterNm({
      type: 'delete',
      client: row.customer,
      id: row.idNm,
      pieces
    })
    .then(data => {
      setTable(data.tableData)
      setIsLoading(false)
      setLoadingFilters(false)
      onCancelClick()
    })
      .catch(error => {
        toast.error(t('errors.' + error))
        setIsLoading(false)
      })
  }
 
  
  const onSaveClick = () => {
    if (!validateForm())
      return;

    setIsLoading(true)
    SafetyStockCrudRegisterNm({
      type: 'save',
      client: selectedClient.map(x => { return x.value }),
      nm: selectedNm.map(x => { return x.value }),
      pieces,
      plant,
      contract
     }).then(data => {
       setTable(data.tableData)
       setIsLoading(false)
       setLoadingFilters(false)
       onCancelClick()
     })
     .catch(error => {
       toast.error(t('errors.' + error))
       setIsLoading(false)
     })
   }
  
  return (
    <>
      <Grid>
        <FlexView flex="1" position="relative" alignSelf="stretch" margin="16px 250px 0px" padding="0px 5px">
          {/* <FlexView flexDirection="row" margin="16px 250px 0px" padding="0px 10px"> */}
          
          <FlexView flexDirection="column" margin="0px 5px 0px 0px" padding="0px">
            <FlexView flexDirection="row" margin="0px 5px 0px 0px" padding="0px">
              <FlexView flexDirection="column" margin="0px 5px 0px 0px" padding="0px">
                <LabelMultiselect label={t('safety.register.client')} />
                <Multiselect selectionLimit={1} selectedValues={selectedClient} options={clients} onSelect={onClientSelect} onRemove={onClientSelect} displayValue="label" showCheckbox={true} closeOnSelect={true} placeholder="Search..."
                emptyRecordMsg="No values to select" style={multiselectCss} loading={loadingFilters} loadingMessage="Loading Material..." />
              </FlexView>
              <FlexView flexDirection="column" margin="0px 5px 0px 0px" padding="0px">
                <LabelMultiselect label={t('safety.register.nm')} />
                <Multiselect selectionLimit={1} width="100%" selectedValues={selectedNm} options={nms} onSelect={onNmSelect} onRemove={onNmSelect} displayValue="label" showCheckbox={true} closeOnSelect={true} placeholder="Search..."
                  emptyRecordMsg="No values to select" style={multiselectCss} loading={loadingFilters} loadingMessage="Loading Purchase..." />
              </FlexView>
            </FlexView>
            <FlexView flexDirection="column" margin="0px 5px 0px 0px" padding="0px">
              <FlexView flexDirection="row" margin="0px 5px 0px 0px" padding="0px">
                <Input  label={t('safety.table.total')} width="100%" onChange={handleInputChange} name="pieces" value={pieces} onKeyDown={handleKeyDown} /> &nbsp;&nbsp;&nbsp;
                <Input label={t('safety.table.plant')} width="100%" onChange={handleInputChange} name="plant" value={plant} onKeyDown={handleKeyDown} />
              </FlexView>
            </FlexView>
            <Input margin="0px 4px 0px 0px" label={t('safety.table.contract')} width="100%" onChange={handleInputChange} name="contract" value={contract} onKeyDown={handleKeyDown} />
            {
              edit
                  ?
                  <FlexView flexDirection="column"   margin="0px 5px 0px 0px" padding="0px">
                    <Button backgroundColor="primary" color="white" fontSize="big" onClick={onUpdateClick} >{t('safety.update')}</Button>
                    <Button backgroundColor="primary" color="white" fontSize="big" onClick={onCancelClick} >{t('safety.cancel')}</Button>
                  </FlexView>
                :
                <Button backgroundColor="primary" color="white" fontSize="big" onClick={onSaveClick} >{t('safety.save')}</Button>
            }
          </FlexView>
        </FlexView>
      </Grid>
      {
        isLoading ?
          <FlexView justifyContent="center" alignItems="center" width="100%" height="100%">
            <Spinner />
          </FlexView>
          :
          <Card alignSelf="stretch" padding="8px 16px" margin="16px 250px 0px" flex="1">
            {
              table.length > 0 ?
                <Table width="100%"
                  columns={columns}
                  data={table}
                  sortable
                  elevation="none"
                  borderRadius="card"
                  paginated
                  margin="8px 16px"
                  style={{ whiteSpace: "nowrap" }}
                />
                :
                <FlexView flex="1" width="100%" height="100%" alignItems="center" padding="50px" fontSize="big" fontWeight="bold" color="gray" backgroundColor="transparent">
                  No Data
                </FlexView>
            }
          </Card>
      }
    </>
  )
}

export default SafetyRegisterNm
